import { render, staticRenderFns } from "./ConfirmCode.vue?vue&type=template&id=68394960&scoped=true&"
import script from "./ConfirmCode.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCode.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCode.vue?vue&type=style&index=0&id=68394960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68394960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VCol,VForm,VImg,VLabel,VRow,VTextField})
